// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDenomination_container__JgMxy"};